import { ENV } from "./utils/const";

import React from "react";

import { RouteRecord } from "vite-react-ssg";


import { blogRoutes } from "./_blog/routes";
import landingGroups from "./content/landingPaths.json";
import SyncLanding from "./pages/SyncLanding";

import ErrorBoundary from './components/ErrorBoundary';

type PageLoader = () => Promise<{ default: React.ComponentType }>;

const pageLoaders: { path: string; load: PageLoader }[] = [
  { path: "", load: () => import("./pages/Home") },
  { path: "privacy", load: () => import("./pages/Privacy") },
  { path: "tos", load: () => import("./pages/Tos") },
  { path: "google-privacy", load: () => import("./pages/GoogleDisclosure") },
  { path: "for-freelancers", load: () => import("./pages/ForFreelancer") },
  { path: "blog", load: () => import("./pages/Blog") },
  { path: "login", load: () => import("./pages/Login") },
  { path: "dashboard", load: () => import("./pages/Dashboard") },
  { path: "mcp", load: () => import("./pages/Mcp") },
  { path: "mcp-done", load: () => import("./pages/McpDone") },
  { path: "admin", load: () => import("./pages/Admin") },
  { path: "plan", load: () => import("./pages/Plan") },
  { path: "payment", load: () => import("./pages/Payment") },
  { path: "book", load: () => import("./pages/SchedulerPage") },
  { path: "404", load: () => import("./pages/page404") },
  { path: "*", load: () => import("./pages/page404") },
];

// A fresh lazy component per route. vite-react-ssg reads Component._payload._result
// during SSG, and React 19 replaces that with a module namespace (no toString)
// once the shared lazy() has already rendered for another language.
let routes: RouteRecord[] = pageLoaders.flatMap((route) =>
  ["/", "/en/", "/fr/", "/it/", "/es/"].map((language) => ({
    path: language.concat(route.path),
    Component: React.lazy(route.load),
    ErrorBoundary,
  }))
);

// Blog routes
routes = routes.concat(
  blogRoutes.map(
    ([url, Component]) => (
      { path: `${url}`, Component: Component, ErrorBoundary: ErrorBoundary } as RouteRecord)
  )
);

routes = routes.concat(
  landingGroups.flatMap((group) =>
    Object.values(group.paths).map((path) => ({
      path,
      Component: function LandingPage() {
        return <SyncLanding id={group.id} />;
      },
      ErrorBoundary,
    }))
  )
);

export default routes;